import {startOfToday, startOfTomorrow} from 'date-fns'
import {useMemo, useSyncExternalStore} from 'react'

function subscribe(onChange: () => void) {
  let timer: ReturnType<typeof setTimeout>
  const schedule = () => {
    // Bound stale dates after clock or time-zone changes without delaying midnight updates.
    timer = setTimeout(
      () => {
        onChange()
        schedule()
      },
      Math.min(startOfTomorrow().getTime() - Date.now(), 5 * 60_000),
    )
  }
  schedule()
  return () => clearTimeout(timer)
}

// A number, so the snapshot is stable within a day and changes at local midnight
const getSnapshot = () => startOfToday().getTime()

/** The start of the current local day; re-renders the caller when the day changes. */
export function useToday() {
  const timestamp = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
  return useMemo(() => new Date(timestamp), [timestamp])
}
